// **********************************************************
//  Hospital List
// **********************************************************
/* eslint-disable */
$(function () {
  $('.hospital-list-tab-nav__link').click(function (e) {
    $(this).siblings().removeClass('is-active');
    $(this).addClass('is-active');

    $('[data-destination]').removeClass('is-active');

    $('[data-destination=' + $(this).attr('data-target') + ']').addClass('is-active');

    e.preventDefault();
  });
});
/* eslint-enable */
